import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { DataService } from "../../data.service";
import { TrackDataModel } from "../../model";
import { TrackUtils } from "../../shared/track-utils";
import { AppServerError } from "../../common/errors";
import { alertMessage, confirmMessage } from "../../shared/message-utils";
import { ConfirmationService } from "primeng/api";

@Component({
    selector: "app-add-track",
    templateUrl: './add-track.component.html',
    standalone: false
})
export class AddTrackComponent implements OnChanges {
    @Input() visible: boolean = false;
    @Input() trackData?: TrackDataModel;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onHide = new EventEmitter<void>();

    tracknum: string = "";
    title: string = "";
    editMode: boolean = false;

    constructor(private dataService: DataService, private confirmationService: ConfirmationService) {

    }
    ngOnChanges(changes: SimpleChanges): void {
        this.tracknum = this.trackData?.tracknum ?? "";
        this.title = this.trackData?.title ?? "";
        this.editMode = this.trackData !== undefined;
    }

    addTrack() {
        let tracknum = TrackUtils.checkTrack(this.tracknum);
        const title = this.title;
        if (!tracknum) {
            confirmMessage(this.confirmationService, TrackUtils.alertMessage,
                // accept fn
                () => {
                    tracknum = this.tracknum;
                    const subscr = this.dataService.addClientTrack(tracknum!, title, false).subscribe({
                        next: (data) => {
                            this.hideDialog();
                        },
                        error: (e) => {
                            subscr.unsubscribe();
                            if (e && e instanceof AppServerError) {
                                if (e.errData.message === 'already_exists') {
                                    confirmMessage(
                                        this.confirmationService,
                                        "Данный трек уже загружен в систему. Обновить?",
                                        () => {
                                            const subscr2 = this.dataService.addClientTrack(tracknum!, title, true).subscribe({
                                                complete: () => {
                                                    subscr2.unsubscribe();
                                                    this.hideDialog();
                                                },
                                                error: (err) => {
                                                    subscr2.unsubscribe();
                                                    alertMessage(this.confirmationService, err.message ? err.message : JSON.stringify(err));
                                                    this.hideDialog();
                                                }
                                            });
                                        },
                                        () => {
                                            this.hideDialog();
                                        }
                                    );
                                } else {
                                    alertMessage(this.confirmationService, `Ошибка создания трека. ${e.errData.message}`);
                                    this.hideDialog();
                                }
                            } else {
                                alertMessage(this.confirmationService, e.message ? e.message : JSON.stringify(e));
                                this.hideDialog();
                            }
                        },
                        complete: () => {
                            subscr.unsubscribe();
                        }

                    });
                },
                // reject fn
                () => { }
            );
        }

    }

    editTrack() {
        const tracknum = TrackUtils.checkTrack(this.tracknum);
        if (!tracknum) {
            alert(TrackUtils.alertMessage);
            return;
        }

        // this.dataService.editTrack(
        //     {
        //         originalTrackNum: this.originalTrackNum,
        //         tracknum: this.trackNum,
        //         title: this.trackDescr,
        //         comment: ""
        //     }
        // ).subscribe(
        //     (data) => {
        //         // reload tracks
        //         this.dataSubscription.unsubscribe();
        //         this.dataSubscription = this.dataService.myTracks().subscribe(
        //             (tracks: TrackDataModel[]) => {
        //                 this.tracks = tracks;
        //             }
        //         );

        //         this.cancelTrack();
        //     }
        // );
    }

    hideDialog() {
        this.tracknum = "";
        this.title = "";
        this.visibleChange.emit(false);
        this.onHide.emit();
    }
}